import { automationConfigurationUris } from "@/features/automation-configuration/AutomationConfiguration.config";

export const hideTopbarRoutes = ["explore", "quality", "notices"];

// 💡 hint: to hide top bar put the path here 💡
export const hideTopbarPaths = [
  "/",
  `${automationConfigurationUris.root}/:page`,
  "/playground",
  "/demo",
  "enrichments/new",
  "/automation",
  "/automation-center",
  "/automation-center/training",
  "/automation-center/skills/*",
  "/automation-center/enrichments",
  "/automation-center/enrichments/:enrichmentId",
  "/automation-center/enrichments/:enrichmentId/sync",
  "/automation/:simulationId",
  "/automation-copilot/:simulationId",
  "/copilot/:tenantId/ticket/:ticketId",
  "/knowledge-management/gaps",
  "/knowledge-management/articles",
  "/knowledge-management/knowledge-hub",
  "/knowledge-management/gaps/:groupId",
  "/automation/:simulatorId/versions",
  "/automation/:simulatorId/versions/:versionId",
  "/automation/:simulatorId/versions/:versionId/activity",
  "/automation/:simulatorId/activity",
  "/enrichments",
  "/enrichments/:enrichmentId",
  "/enrichments/:enrichmentId/sync",
  "/enrichments/new",
  "/playground-v2",
  "/automation/:simulatorId/:topicId/live-test",
  "/settings",
  "/settings/data-sources",
  "/settings/members",
  "/settings/agents",
  "/settings/topics",
  "/settings/brands",
  "settings/billing",
  "/trackers",
  "/trackers/:trackerId",
  "/approval-requests",
  "/getting-started",
  "/admin-dashboard",
  "/training-center/*",
  "/settings/:page",
  "/knowledge-management-editor",
  "/skills/:skillId/browser",
  "/custom-report/:exploreViewId",
  "/pages/:pageId",
  "/journeys",
  "/pages",
  "/automation-center/regression-sets",
  "/automation-center/regression-tests",
  "/automation-center/compare/regression-sets/:id/regression-tests/:id1/:id2",
  "/automation-center/aui-regression-tests",
  "/automation-center/aui-regression-tests/v2",
  "/automation-center/good-responses-library",
];
